export const ALERTS = {
  PORTRAIT_STATUS_SUCCESS: 'Le statut du portrait a été mis à jour avec succès',
  PORTRAIT_STATUS_ERROR: "Une erreur s'est produite lors de la mise à jour du statut de portrait",
  DOCUMENT_STATUS_SUCCESS: 'Le statut du document a été mis à jour avec succès',
  DOCUMENT_STATUS_ERROR: "Une erreur s'est produite lors de la mise à jour du statut de document",
  IDENTITY_FINALISE_SUCCESS: "L'dentité finalisée avec succès",
  IDENTITY_FINALISE_ERROR: "Une erreur s'est produite lors de la finalisation de l'identité"
};
